console.log("Vite ⚡️ Rails");
console.log(
  "Visit the guide for more information: ",
  "https://vite-ruby.netlify.app/guide/rails"
);

console.log(import.meta.env.RAILS_ENV);
console.log(import.meta.env);

// Styles
import "~/stylesheets/index.scss";
// Import style for flatpickr
import "flatpickr/dist/flatpickr.css";
// Import style for tom-select
import 'tom-select/dist/css/tom-select.bootstrap5.css'

// JS
import Cookies from "js-cookie";
window.Cookies = Cookies;

import $ from "jquery";
Object.assign(window, { jQuery: $, $ });

// Import all of Bootstrap's JS
import * as bootstrap from "bootstrap";
// or, specify which plugins you need:
// import { Tooltip, Toast, Popover } from 'bootstrap';

import "~/controllers";
import "@hotwired/turbo-rails";
import "@nathanvda/cocoon";
// import Flatpickr
import Flatpickr from "stimulus-flatpickr";

window.bootstrap = bootstrap;
window.Flatpickr = Flatpickr;

// Load Rails libraries in Vite.
import * as Turbo from "@hotwired/turbo";
import * as ActiveStorage from "@rails/activestorage";
import DirectUpload from "~/utils/direct_uploads";

Turbo.start();
ActiveStorage.start();
DirectUpload.start();

// initialize the page
window.addEventListener("turbo:load", (_event) => {
  console.log("turbo:load");
  initPage();
});

// import "bootstrap-fileinput/js/fileinput";
// import "~/vendor/fileinput";

// window.addEventListener("turbo:render", (_event) => {
//   console.log("turbo:render");
//   initPage();
//   createIcons({ icons });
// });

function initPage() {
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
  const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

  // initialize popovers
  const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
  // let popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
  //   return new bootstrap.Popover(popoverTriggerEl);
  // });
  [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl))

  // Set the browser's timezone in a cookie for retrieval on the server
  console.log(Intl.DateTimeFormat().resolvedOptions().timeZone);
  if (location.protocol === "https:") {
    Cookies.set("browser.timezone", Intl.DateTimeFormat().resolvedOptions().timeZone, { expires: 365, secure: true })
  } else {
    // allow for readable cookie value in dev/test
    Cookies.set("browser.timezone", Intl.DateTimeFormat().resolvedOptions().timeZone, { expires: 365 })
  }
}
